import styled, { css } from "styled-components";

import { colors } from "global/globalStyle";

interface IProps {
  widthHeight?: number;
}

export const Container = styled.button<IProps>`
  width: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "40px")};
  height: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "40px")};
  background-color: ${colors.default_base_black_menu_1};
  border-radius: 50%;
  border: 2px ${colors.default_blue} solid;
  cursor: pointer;

  ${(props) =>
    props.disabled
      ? css`
          border-color: #7887a9;
          cursor: default;
        `
      : css`
          &:hover {
            border-color: ${colors.default_base_white};
            background-color: ${colors.default_dark_blue};
            background: ${colors.default_dark_blue};
          }
        `}
`;

export const PlusIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.default_base_white};
  font-size: 20px;
`;
